import { action, observable } from 'mobx'
// Request
// Current user
import { CateDocumentRequest } from '../requests/CateDocumentRequest'
import { CateRequest } from '../requests/CateRequest'

class CateDocumentStore {
  @action setFilter = (filterName, filterValue) => {
    if (typeof filterName !== 'string') return
    this[filterName] = filterValue
  }

  /** Incoming Document */

  @observable documentTypeList = []

  @action listDocumentsType = () => {
    if (!this.documentTypeList || this.documentTypeList.length === 0) {
      return new Promise((resolve, reject) => {
        CateRequest.listDocumentType()
          .then(response => {
            this.documentTypeList = response.data
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }
  @observable documentStatusList = []

  @action listDocumentsStatus = () => {
    if (!this.documentStatusList || this.documentStatusList.length === 0) {
      return new Promise((resolve, reject) => {
        CateRequest.listDocumentStatus()
          .then(response => {
            this.documentStatusList = response.data
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  }

  @action getDocumentsIncoming = param => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.getDocumentsIncoming(param)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDocumentsOutgoing = param => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.getDocumentsOutgoing(param)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDocumentsIncomingById = docId => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.getDocumentsIncomingById(docId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action getDocumentsOutgoingById = docId => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.getDocumentsOutgoingById(docId)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action createCateDocument = documentInfo => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.createCateDocument(documentInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action updateCateDocument = documentInfo => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.updateCateDocument(documentInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  @action sentCateDocument = documentInfo => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.sentDocument(documentInfo)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action reload = () => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.reload()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action reloadStatus = () => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.reloadStatus()
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action reloadIncoming = data => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.reloadIncoming(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
  @action updateReceivedStatus = data => {
    return new Promise((resolve, reject) => {
      CateDocumentRequest.updateReceivedStatus(data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

export default new CateDocumentStore()
